@if (areaService.accNameStatus().status !== 'Loaded') {
<acc-loading-part></acc-loading-part>
}

@else {
<div class='acc-cohort-page'>

	<toolbar icon='Delivery'>

		<button class="btn btn-light" (click)='areaService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i
				class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<div style='display:inline-block;width:400px'>
			<accelerator-droplist></accelerator-droplist>
		</div>

	</toolbar>

	<page-tabs [tabNames]='["Cohort", "Links", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>

		<ng-template pageTab1>
			<acc-cohort-views-part></acc-cohort-views-part>
		</ng-template>

		<ng-template pageTab2>
			<acc-cohort-tab-1-part></acc-cohort-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<acc-cohort-tab-2-part></acc-cohort-tab-2-part>
		</ng-template>

	</page-tabs>

</div>
}